export default __webpack_public_path__ + "static/media/Karanji Lake.c3a9c57f.jpg";